import { CompetitionLanding, freePlanFaqAnswer } from './CompetitionLanding';
import type { FreeLimits } from '../types';

const config = {
  slug: 'copa-do-mundo',
  routeId: 'pool-copa-do-mundo',
  seoTitle: 'Bolão Copa do Mundo 2026 — Crie e dispute com amigos grátis | Bolão Elite',
  seoDescription:
    'Crie o bolão da Copa do Mundo FIFA 2026 (EUA, Canadá e México) grátis e convide amigos. Palpite no placar de todos os 104 jogos, suba no ranking ao vivo e dispute prêmios. Sem cadastro de cartão.',
  seoKeywords:
    'bolão copa do mundo 2026, bolão copa do mundo com amigos, criar bolão copa 2026, bolão futebol grátis, palpitar copa do mundo 2026, ranking bolão copa, bolão entre amigos copa',
  canonical: 'https://bolaoelite.com.br/bolao-copa-do-mundo',
  heroTitle: 'Bolão da Copa do Mundo 2026',
  heroSubtitle:
    '104 jogos, 48 seleções — palpite em cada partida da Copa do Mundo FIFA 2026 e dispute com amigos em um bolão grátis.',
  accentColor: 'text-sky-600',
  facts: [
    'Primeira Copa com 48 seleções na história da FIFA',
    'Sede tripla: EUA, Canadá e México — 16 cidades',
    '104 jogos no total, recorde em Copas do Mundo',
    '12 grupos de 4 seleções + 8 melhores 3ºs avançam',
  ],
  faqs: [
    {
      question: 'Quando começa a Copa do Mundo 2026?',
      answer: 'A Copa do Mundo FIFA 2026 começa em junho de 2026 com sede nos EUA, Canadá e México. O Bolão Elite abrirá os palpites quando o calendário de jogos for divulgado.',
    },
    {
      question: 'Quantos jogos posso palpitar?',
      answer: 'Todos os 104 jogos da copa — da fase de grupos à grande final. Cada partida tem sua janela de palpites até o apito inicial.',
    },
    {
      question: 'Posso fazer bolão com pessoas de outros países?',
      answer: 'Sim! O Bolão Elite é acessível via web em qualquer dispositivo. Compartilhe o link de convite e qualquer pessoa pode entrar.',
    },
    {
      question: 'O bolão é gratuito?',
      answer: (limits: FreeLimits) => freePlanFaqAnswer(limits),
    },
    {
      question: 'Posso criar vários bolões diferentes para a Copa?',
      answer: (limits: FreeLimits) =>
        `No plano gratuito você cria ${limits.maxPrivatePoolsCreated} bolão privado. Para ter um bolão separado para a família, o trabalho e os amigos, faça upgrade para o Premium e crie bolões ilimitados.`,
    },
    {
      question: 'Existe um simulador de bracket da Copa do Mundo 2026?',
      answer: 'Sim! O Bolão Elite oferece um simulador interativo gratuito onde você monta o bracket completo da Copa do Mundo 2026 com 48 seleções. Acesse em bolaoelite.com.br/simulador-copa-do-mundo-2026.',
    },
  ],
  jsonLd: {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name: 'Copa do Mundo FIFA 2026',
    startDate: '2026-06-01',
    location: {
      '@type': 'Place',
      name: 'EUA, Canadá e México',
    },
    organizer: {
      '@type': 'Organization',
      name: 'FIFA',
    },
  },
};

export default function LandingCopaMundo() {
  return <CompetitionLanding config={config} />;
}
